import { Route } from '@angular/router';

export const transactionRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'list',
    pathMatch: 'full',
  },
  {
    path: 'list',
    loadComponent: () => import('./pages').then(p => p.TransactionListPage),
    title: 'UIMS - Transaction',
  },
  {
    path: 'details/:id',
    loadComponent: () => import('./pages').then(m => m.TransactionDetailsComponent),
    title: 'UIMS - Transaction Details',
  },
];
